/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const MentalHealthIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 24 24'
			style={{
				enableBackground: 'new 0 0 24 24'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<style>{`.st0{fill: ${color}}`}</style>
			<path
				className='st0'
				d='M9.5 2.7C8.3 2.9 7.1 3.4 6 4c0 0-3.5 1.7-2.8 6.4.1.5 0 1-.1 1.5L1 14.4v.1c-.2.3-.1.7.1 1 .2.3.5.5.8.5l1 .2c.2.5.4.9.5 1.4 0 .6 0 1.1-.1 1.7-.4 1.3.1 1.9.5 2.2h.1c.3.2 1.1.6 4.3-.1.2.6.3 1.2.4 1.9 0 .2.2.4.5.4v-.1.1c.2 0 .4-.1.4-.3v-.3c-.2-1.8-.6-2.4-.8-2.7-.1-.2-.3-.2-.5-.2-1.9.5-3.5.6-4 .3h-.1c-.3-.3-.1-.9 0-1.1v-.1c.1-.5.1-.9.1-1.4h1.4c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H4.1c-.1-.4-.2-.9-.5-1.4-.1-.2-.2-.3-.4-.3l-1.4-.3h-.1v-.1l2.1-2.4c.3-.7.4-1.4.3-2.2-.6-4 2.2-5.3 2.3-5.3 1-.6 2.1-1 3.2-1.2.3 0 .5-.3.4-.6 0-.2-.2-.4-.5-.4zM18.5 14.8c-.3-.1-.6 0-.7.2-.7 1.2-1.2 2.5-1.5 3.9 0 1.5.1 3 .4 4.5v.1l.5-.1.6-.1v-.1c-.3-1.4-.4-2.8-.4-4.2.3-1.2.7-2.4 1.3-3.5.2-.2.1-.5-.2-.7zM17 4s-.1 0 0 0c-.7 0-1.3.2-1.8.6-.6-.4-1.2-.6-1.9-.6-.8 0-1.5.3-2 .9-1 1.1-.9 2.9.2 3.9l3.3 3.1c.1.1.2.1.4.2.1 0 .3 0 .4-.2l3.3-3C20 7.7 20 6 19 4.9c-.5-.5-1.3-.9-2-.9zm1.6 2.9c0 .4-.2.8-.5 1.1l-2.9 2.7L12.3 8c-.6-.6-.7-1.6-.1-2.3.3-.3.8-.5 1.2-.5.4 0 .8.2 1.1.5l.2.2c.2.2.6.2.8 0l.2-.2c.3-.3.7-.5 1.2-.5h.1c.5 0 .9.2 1.2.5.3.3.4.7.4 1.2zM17.7 2.5h.2c.2 0 .4-.1.4-.3l.6-1.4V.4c0-.1-.1-.2-.3-.3-.2-.1-.5 0-.6.3l-.6 1.4c-.1.3 0 .6.3.7zM12.4 2.2c.1.1.1.2.3.2h.4c.2-.1.3-.4.2-.6L12.7.4V.3c-.1-.1-.1-.2-.3-.2H12c-.2.1-.3.4-.2.6l.6 1.5zM12.1.4zM22.8 10.8l-1.4-.6H21c-.1 0-.2.1-.3.3v.4c0 .2.3.1.4.1l1.4.6h.2c.2 0 .4-.1.4-.3.1-.2 0-.5-.3-.5zM21.1 6.1h.4l1.4-.6c.2-.1.3-.4.2-.6v-.1c-.1-.2-.4-.3-.6-.2l-1.4.6c-.1.1-.2.1-.2.3v.3c0 .1.1.2.2.3z'
			/>
		</svg>
	)
}

export default MentalHealthIcon
